import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { GLOBAL_STATE, MODULES, MODULES_ALL, MODULES_LIST } from '../constants/actionTypes'

export const modulesSelectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const modulesSelector = createSelector(modulesSelectors, data => data[MODULES])

export const modulesListSelector = createSelector(modulesSelectors, data => data[MODULES_LIST])

export const modulesAllSelector = createSelector(modulesSelectors, data => data[MODULES_ALL])
